import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Preset item to inform that last updated times should be displayed
 * @param {PresetItem} Item The item to enhance
 */
export const withLastUpdated: PresetHOC<{
    showLastUpdated?: boolean;
}> = (Item) => {
    Item.showLastUpdated = true;

    return Item;
};
